"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePosElementwise = void 0;
var updatePosElementwise = function (from, updateFn) {
    return from.withMutations(function (rect) { return rect.update('x', updateFn).update('y', updateFn); });
};
exports.updatePosElementwise = updatePosElementwise;
